import YoutubeVideo from 'components/youtube-video/YoutubeVideo';
//import Button from 'components/button/button';

import { IVideoBlock } from 'source/NFR.types';

const VideoBlock: React.FC<React.PropsWithChildren<IVideoBlock>> = ({
  children,
  video,
  step,
  title,
  text /*, playText*/
}) => {
  //const [play, setPlay] = useState();

  return (
    <div className="video-block">
      {children}
      <div className="video-block--video">
        <YoutubeVideo /*play={play}*/ {...video} />
      </div>
      <div className="video-block--content">
        <h2 className="video-block--title">
          <span className="video-block--title-upper">{step}</span>
          {title}
        </h2>
        <p className="video-block--text">{text}</p>
        {/*<Button
          className="video-block--button"
          theme=["primary", "large"]
          text={playText}
          onClick={() => setPlay(true)}
        /> */}
      </div>
    </div>
  );
};

VideoBlock.displayName = 'VideoBlock';

export default VideoBlock;
